import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Profile, ProfileComponent } from '@nx/domain';

export interface PublicProfileState {
  profile: Profile | null;
  components: ProfileComponent[];
  loading: boolean;
  error: string | null;
  notFound: boolean;
}

const initialState: PublicProfileState = {
  profile: null,
  components: [],
  loading: false,
  error: null,
  notFound: false,
};

const publicProfileSlice = createSlice({
  name: 'publicProfile',
  initialState,
  reducers: {
    publicProfileLoadRequested(state, _action: PayloadAction<string>) {
      state.loading = true;
      state.error = null;
      state.notFound = false;
    },
    publicProfileLoaded(
      state,
      action: PayloadAction<{ profile: Profile; components: ProfileComponent[] } | null>,
    ) {
      state.loading = false;
      if (!action.payload) {
        state.profile = null;
        state.components = [];
        state.notFound = true;
        return;
      }
      state.profile = action.payload.profile;
      state.components = action.payload.components;
      state.notFound = false;
    },
    publicProfileFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  publicProfileLoadRequested,
  publicProfileLoaded,
  publicProfileFailed,
} = publicProfileSlice.actions;

export default publicProfileSlice.reducer;
